module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap personal-wrap flex-column"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "grid-tip tip"
  }, [_vm._v("\n      快来取个有逼格的名字吧~\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "edit"
  }, [_c('li', {
    staticClass: "user-order-title"
  }, [_c('p', [_c('label', [_vm._v("昵称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nickName),
      expression: "nickName"
    }],
    staticClass: "right",
    attrs: {
      "placeholder": "请输入昵称"
    },
    domProps: {
      "value": (_vm.nickName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "editButton"
  }, [_c('mu-raised-button', {
    attrs: {
      "label": "保存",
      "fullWidth": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  })], 1)]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "昵称不能为空  *__*"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.successMsg) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": "修改成功!"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0030a85e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/editnickname.vue
// module id = 372
// module chunks = 68